import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {User, UserState,OtpReturn} from '@/store/modules/user/types';
import {RootState} from '@/store/types';
import {userAPI, UserLoginMsg} from '@/api/user';

export const moduleName = "user";

export enum UserGetters {
    getUserInfo = "GET_USER_INFO",
    getUserList = "GET_USER_LIST",
    getIsLoading = "GET_IS_LOADING",
}

export enum UserMutations {
    login = "USER_LOGIN",
    logout = "USER_LOGOUT",
    setUserList = "SET_USER_LIST",
    setIsLoading = "SET_IS_LOADING",
}

export enum UserActions {
    login = "LOGIN",
    logout = "LOGOUT",
    asyncGetUserList = "ASYNC_GET_USER_LIST",
    asyncCreateUser = "ASYNC_CREATE_USER",
    asyncDeleteUser = "ASYNC_DELETE_USER",
    asyncUpdateUser = "ASYNC_UPDATE_USER",
    asyncGetOwnInfo = "ASYNC_GET_OWN_INFO",
    asyncCheckOtpExist = "ASYNC_CHECK_OTP_EXIST",
    asyncGetPanelList = "ASYNC_GET_PANEL_LIST",
}

const state: UserState = {
    user: null,
    userList: [],
    isLoading: false,
};

export const getters: GetterTree<UserState, RootState> = {
    [UserGetters.getUserInfo](state): User | null {
        return state.user;
    },
    [UserGetters.getUserList](state): User[] {
        return state.userList;
    },
    [UserGetters.getIsLoading](state): boolean {
        return state.isLoading;
    },
}

const mutations: MutationTree<UserState> = {
    [UserMutations.login](state, payload: User): void {
        state.user = payload;
    },
    [UserMutations.logout](state): void {
        state.user = null;
    },
    [UserMutations.setUserList](state, payload: User[]): void {
        state.userList = payload;
    },
    [UserMutations.setIsLoading](state, payload: boolean): void {
        state.isLoading = payload;
    },

}

const actions: ActionTree<UserState, RootState> = {
    async [UserActions.login]({ commit }, loginMsg: UserLoginMsg): Promise<boolean> {
        try {
            const loginRes = await userAPI.login(loginMsg);
            commit(UserMutations.login, loginRes);
            localStorage.setItem("at_l_token", loginRes.token);
            if (loginRes) {
                return true
            } else {
                return false;
            }
        } catch (err) {
            console.log(err);
            return false;
        }
    },
    async [UserActions.logout]({ commit }): Promise<void> {
        try {
            const res = await userAPI.logout();
            if (res) {
                commit(UserMutations.logout);
                localStorage.removeItem("at_l_token");
            }
        } catch (err) {
            console.log(err);
        }
    },
    async [UserActions.asyncGetUserList]({ commit }): Promise<void> {
        try {
            commit(UserMutations.setIsLoading, true);
            const userList = await userAPI.getUserList();
            commit(UserMutations.setUserList, userList);
        } catch (err) {
            console.log(err);
        } finally {
            commit(UserMutations.setIsLoading, false);
        }
    },
    async [UserActions.asyncCreateUser]({ commit },
        { username, priv, password, isPermanent, expiredTime, moduleList }: { username: string, priv: number, password: string, isPermanent: boolean, expiredTime: string, moduleList: string })
        : Promise<void> {
        try {
            commit(UserMutations.setIsLoading, true);
            await userAPI.createUser({ username: username, priv: priv, password: password, isPermanent: isPermanent, expiredTime: expiredTime, moduleList: moduleList });
        } catch (err) {
            console.log(err);
        } finally {
            commit(UserMutations.setIsLoading, false);
        }
    },
    async [UserActions.asyncDeleteUser]({ commit }, { id }: { id: number })
        : Promise<void> {
        try {
            commit(UserMutations.setIsLoading, true);
            await userAPI.deleteUser(id);
            // commit(UserMutations.setUserList, userList);
        } catch (err) {
            console.log(err);
        } finally {
            commit(UserMutations.setIsLoading, false);
        }
    },
    async [UserActions.asyncUpdateUser]({ commit },
        { userid, username, priv, password, isPermanent, expiredTime, moduleList }: { userid: number, username: string, priv: number, password: string, isPermanent: boolean, expiredTime: string, moduleList: string })
        : Promise<void> {
        try {
            commit(UserMutations.setIsLoading, true);
            await userAPI.updateUser({ id: userid, username: username, priv: priv, password: password, isPermanent: isPermanent, expiredTime: expiredTime, moduleList: moduleList });
            // commit(UserMutations.setUserList, userList);

        } catch (err) {
            console.log(err);
        } finally {
            commit(UserMutations.setIsLoading, false);
        }
    },
    async [UserActions.asyncGetOwnInfo]({ commit })
        : Promise<void> {
        try {
            commit(UserMutations.setIsLoading, true);
            const own = await userAPI.showOwnInfo();
            commit(UserMutations.login, own);

        } catch (err) {
            console.log(err);
        } finally {
            commit(UserMutations.setIsLoading, false);
        }
    },
    async [UserActions.asyncCheckOtpExist]({ commit }, loginMsg: UserLoginMsg): Promise<boolean | string> {
        try {
            return await userAPI.checkIsOtpCodeExist(loginMsg)
        } catch (err) {
            console.log(err);
            return ''
        }
    },
    async [UserActions.asyncGetPanelList]({ commit }, { userId, projId, uid }: { userId: number, projId: string, uid: string }): Promise<string> {
        try {
            commit(UserMutations.setIsLoading, true);
            return await userAPI.GetModuleListByUserAndProjIdAndTargetId({userId: userId, projId: projId, uid: uid})
        } catch (err) {
            console.log(err);
            return ''
        } finally {
            commit(UserMutations.setIsLoading, false);
        }
    },


}

export const user: Module<UserState, RootState> = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}

